import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useCommonHooks } from "../../hooks";
import { useFormTypeRef } from "../../hooks/applicationHooks/useFormTypeRef";
import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface IFormTypeSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const FormTypeSelect: React.FunctionComponent<IFormTypeSelectProps> = ({
  name,
  label,
  loading,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { formTypes, formTypesLoading } = useFormTypeRef();

  return (
    <FGSelectInput
      label={label || t("FormType")}
      name={name}
      items={formTypes}
      loading={formTypesLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default FormTypeSelect;
